import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/auth';
import AuthPageWrapper from '../components/layout/AuthPageWrapper';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      if (!validateEmail(email)) {
        throw new Error('Please enter a valid email address');
      }

      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageWrapper>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-10">
            <div className="forgot-password-card wow fadeInUp" data-wow-delay=".2s">
              {/* Header */}
              <div className="text-center mb-4">
                <h2 className="forgot-password-title">Reset Password</h2>
                <p className="forgot-password-subtitle">
                  Enter your email and we'll send you reset instructions
                </p>
              </div>

              {/* Alerts */}
              {error && (
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                  <i className="lni lni-cross-circle"></i> {error}
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setError('')}
                    aria-label="Close"
                  ></button>
                </div>
              )}

              {success ? (
                <div className="text-center">
                  <div className="alert alert-success mb-3" role="alert">
                    <i className="lni lni-checkmark-circle"></i> Password reset instructions have been sent to your email.
                  </div>
                  <Link to="/login" className="ud-main-btn w-100">
                    Return to Login
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="email"
                      className={`form-control ${email && !validateEmail(email) ? 'is-invalid' : ''}`}
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoFocus
                    />
                    {email && !validateEmail(email) && (
                      <div className="invalid-feedback">
                        Please enter a valid email address
                      </div>
                    )}
                  </div>

                  <button 
                    type="submit" 
                    className="ud-main-btn w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Reset Link'
                    )}
                  </button>

                  <div className="text-center">
                    <Link to="/login" className="text-decoration-none">
                      Back to Login
                    </Link>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </AuthPageWrapper>
  );
};

export default ForgotPassword;
